import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalSupplierDynamicConfigDocument = gql`
  query SalesPortalSupplierDynamicConfig($supplierUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      supplier_metadata {
        dynamic_config
        po_number_display
        show_order_notes
      }
    }
  }
`;
export function useSalesPortalSupplierDynamicConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >(SalesPortalSupplierDynamicConfigDocument, options);
}
export function useSalesPortalSupplierDynamicConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >(SalesPortalSupplierDynamicConfigDocument, options);
}
export type SalesPortalSupplierDynamicConfigQueryHookResult = ReturnType<
  typeof useSalesPortalSupplierDynamicConfigQuery
>;
export type SalesPortalSupplierDynamicConfigLazyQueryHookResult = ReturnType<
  typeof useSalesPortalSupplierDynamicConfigLazyQuery
>;
export type SalesPortalSupplierDynamicConfigQueryResult = Apollo.QueryResult<
  Types.SalesPortalSupplierDynamicConfigQuery,
  Types.SalesPortalSupplierDynamicConfigQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalSupplierDynamicConfigQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalSupplierDynamicConfigQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >(SalesPortalSupplierDynamicConfigDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalSupplierDynamicConfigLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalSupplierDynamicConfigLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalSupplierDynamicConfigQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalSupplierDynamicConfigQuery,
    Types.SalesPortalSupplierDynamicConfigQueryVariables
  >(SalesPortalSupplierDynamicConfigDocument, lazyOptions);
}
